import React from 'react';
import SizeContext from '../SizeContext';

var useSize = function useSize(customSize) {
  var size = React.useContext(SizeContext);
  var mergedSize = React.useMemo(function () {
    if (!customSize) {
      return size;
    }

    if (typeof customSize === 'string') {
      return customSize !== null && customSize !== void 0 ? customSize : size;
    }

    if (customSize instanceof Function) {
      return customSize(size);
    }

    return size;
  }, [customSize, size]);
  return mergedSize;
};

export default useSize;